import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditNavigationGuard } from 'lib-core-shared';
import { MsalGuard } from '@azure/msal-angular';
import { HomePageComponent } from './containers/home/home-page.component';
import { AuthorisationErrorPageComponent } from './containers/errors/authorisation-error-page/authorisation-error-page.component';
import { RedirectToComponent } from './containers/redirect-to/redirect-to.component';
export interface ProductRouteMap {
  name: string;
  fullRouteName: string;
  children?: ProductRouteMap[]
} 
export const productRouteMap = {
  name: 'products',
  fullRouteName: 'products',
  children: [
    {
      name: 'home',
      fullRouteName: 'products/search'
    },
    {
      name: 'search',
      fullRouteName: 'products/search'
    },
    {
      name: 'details',
      fullRouteName: 'products/details',
      children: [
        {
          name: 'core',
          fullRouteName: 'products/details/core'
        },
        {
          name: 'pricing',
          fullRouteName: 'products/details/pricing'
        },
        {
          name: 'info',
          fullRouteName: 'products/details/info'
        },
        {
          name: 'suppliers',
          fullRouteName: 'products/details/suppliers'
        },
        {
          name: 'dimensions',
          fullRouteName: 'products/details/dimensions'
        },
        {
          name: 'text',
          fullRouteName: 'products/details/text'
        },
        {
          name: 'photos',
          fullRouteName: 'products/details/photos'
        },
        {
          name: 'video',
          fullRouteName: 'products/details/video'
        },
        {
          name: 'documents',
          fullRouteName: 'products/details/documents'
        },
      ]
    },
    {
      name: 'new',
      fullRouteName: 'products/new',
    },
    {
      name: 'tag-admin',
      fullRouteName: 'products/tag-admin',
    },
    {
      name: 'skunifaction-dashboard',
      fullRouteName: 'products/skunifaction-dashboard',
    }
  ]
} as ProductRouteMap;

const routes: Routes = [
  {
    path: productRouteMap.name,
    children: [
      { 
        path: productRouteMap?.children ? productRouteMap.children[0].name : '',
        loadChildren: () => import('./containers/product-search/product-search.module').then(m => m.ProductSearchModule),
        canActivate: [MsalGuard]
      },
      { 
        path:  productRouteMap?.children ? productRouteMap.children[2].name : '', 
        loadChildren: () => import('./containers/product-details/product-details.module').then(m => m.ProductDetailsModule),
        canActivate: [MsalGuard]
      },
      { 
        path:  productRouteMap?.children ? productRouteMap.children[3].name : '', 
        loadChildren: () => import('./containers/product-create/product-create.module').then(m => m.ProductCreateModule), 
        canActivate: [MsalGuard] 
      },
      { 
        path:  productRouteMap?.children ? productRouteMap.children[4].name : '', 
        loadChildren: () => import('./containers/tag-admin/tag-admin.module').then(m => m.TagAdminModule), 
        canActivate: [MsalGuard] 
      },
      { 
        path:  productRouteMap?.children ? productRouteMap.children[5].name : '', 
        loadChildren: () => import('./containers/skunification/skunification.module').then(m => m.SkunificationModule), 
        canActivate: [MsalGuard] 
      },
      {
        path: 'message-receiver',
        loadChildren: () => import('./containers/message-receiver/message-receiver.module').then(m => m.MessageReceiverModule)
      },
      {
        path: 'auth-redirect',
        component: AuthorisationErrorPageComponent,
      },
      {
        path: 'redirect-to',
        component: RedirectToComponent,
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' } 
    ],
  },
  {
    path: '', 
    redirectTo: 'products',
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [HomePageComponent],
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: 'enabled',
    scrollOffset: function() {
      //gets the height of any sticky header on the page, so we can offset scrolling etc to account for it
      let matchedElements = window.document.getElementsByClassName('header-sticky');
      if(matchedElements?.length == 1){
        return [0, matchedElements[0].clientHeight]
      }else{
        return [0, 0];
      }
    }
  })],
  exports: [RouterModule],
  providers: [EditNavigationGuard]
})
export class AppRoutingModule { }
